import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const ADD_YEEKEE_TO_STACK = 'ADD_YEEKEE_TO_STACK'
const DELETE_YEEKEE_FROM_STACK = 'DELETE_YEEKEE_FROM_STACK'
const EDIT_YEEKEE_IN_STACK = 'EDIT_YEEKEE_IN_STACK'
const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createYeekee: '+ ADD_YEEKEES)

const yeekee_obj = {
    namespaced: true,
    state: {
        yeekee: []
    },
    mutations: {
        ADD_YEEKEE_TO_STACK (state, yeekee_obj) {
            state.yeekee.unshift(yeekee_obj)
        },
        DELETE_YEEKEE_FROM_STACK (state, yeekee_obj) {
            if (state.yeekee.length) {
                let i = state.yeekee.map(yeekee_obj => yeekee_obj.id).indexOf(yeekee_obj.id)
                state.yeekee.splice(i, 1)
            }
        },
        EDIT_YEEKEE_IN_STACK (state, yeekee_obj) {
            if (state.yeekee.length) {
                let i = state.yeekee.map(yeekee_obj => yeekee_obj.id).indexOf(yeekee_obj.id)
                Vue.set(state.yeekee, i, yeekee_obj)
            }
        },
        LOGOUT_USER (state) {
            state.yeekee = []
        }
    },
    getters: {
        yeekee (state) {
            return state.yeekee
        }
    },
    actions: {
        // API Calls
        async getYeekeeRound ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                //console.log('getAllBetLimit data: ', data)
                //const response = await axios.get('yeekee', {params: {round: data.round, lottotype_id: data.lottotype_id, bettype_id: data.bettype_id, number: data.number,}})
                const response = await axios.get('yeekee', {params: {round: data.round, order: data.order, page: data.page, limit: data.limit}})
                //console.log('getAllBetLimit: ', response)
                //commit(ADD_YEEKEES, response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getYeekee ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('yeekee/' + data)
                //console.log('getYeekee: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async createYeekee ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createYeekee data: ', data)
            try {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.post('yeekee', data)
                return response.data
            } catch (error) {
                throw error
            }
        },


        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
        async addYeekeeToStack ({ dispatch, commit, getters, rootGetters }, yeekee_obj) {
            try {
                commit(ADD_YEEKEE_TO_STACK, yeekee_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async deleteYeekeeFromStack ({ dispatch, commit, getters, rootGetters }, yeekee_obj) {
            try {
                commit(DELETE_YEEKEE_FROM_STACK, yeekee_obj)
            } catch (error) {
                throw new Error(error)
            }
        },
        async editYeekeeInStack ({ dispatch, commit, getters, rootGetters }, yeekee_obj) {
            try {
                commit(EDIT_YEEKEE_IN_STACK, yeekee_obj)
            } catch (error) {
                throw new Error(error)
            }
        }
    }
}

export default yeekee_obj
